export default __webpack_public_path__ + "static/media/aRefer.5266ddab.svg";